import axios from '@/libs/axios';
import JwtService from './jwtService';

const jwt = new JwtService(axios, {});
export default jwt;
